// Used as the id for the car filter html element.
export const CAR_FILTER_ID = "tor-car-filter";
